import React from "react";
import Select from "react-select";

function StoreFilter({ store, storess, onChangeStore }) {
  return (
    <div className="col-sm-4">
      <Select
        className="basic-single"
        classNamePrefix="select"
        placeholder="Select Store"
        options={[
          ...store.map((store) => ({
            value: store.name,
            label: store.name.replace(/_/g, " "),
          })),
        ]}
        onChange={(selected) => onChangeStore(selected.value)}
        value={
          storess
            ? [
                ...store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ].find((option) => option.value === storess)
            : null
        }
      />
    </div>
  );
}

export default StoreFilter;
